module.exports = __webpack_public_path__ + "static/media/03.9484a1e4.png";